<script setup lang="ts">
const links = [
	{ to: '/', translation_key_label: 'home_page' },
	{ to: 'cars', translation_key_label: 'cars' },
	{ to: 'about-us', translation_key_label: 'about_us' },
	{ to: 'faq', translation_key_label: 'faq' },
	{ to: 'contact', translation_key_label: 'contact' },
	{ to: 'https://aplikacja.carfree.pl/', translation_key_label: 'app', link: true, rel: 'nofollow', newTab: true },
	{ to: 'blog', translation_key_label: 'news' },
]

const linksOffer = [
	{ to: 'short-term', translation_key_label: 'car_rental_for_days' },
	{ to: 'medium-term', translation_key_label: 'car_rental_for_month' },
	{ to: 'long-term', translation_key_label: 'car_rental_long_term' },
	{ to: 'bus-rental', translation_key_label: 'bus_rental' },
	{ to: 'delivery-bus-rental', translation_key_label: 'delivery_van_rental' },
	{ to: 'rent-tesla', translation_key_label: 'tesla_rental' },
	{ to: 'electric-car-rental', translation_key_label: 'electric_car_rental' },
	// { to: 'cars', translation_key_label: 'replacement_car' },
]
</script>

<template>
	<div class="links-and-app">
		<div>
			<p class="links-and-app__title">CarFree</p>
			<GlobalFooterLinks :data="links" />
		</div>
		<div>
			<p class="links-and-app__title">{{ $t('components.footer.links_and_app.title_offer') }}</p>
			<GlobalFooterLinks :data="linksOffer" />
		</div>
		<div class="links-and-app__container">
			<p class="links-and-app__download-text">
				{{ $t('components.footer.links_and_app.download_our_app') }}:<br />{{ $t('components.footer.links_and_app.with_code') }}
				<span class="links-and-app__download-text-discount">"START100"</span><br />
				{{ $t('components.footer.links_and_app.and_gain') }}
				<span class="links-and-app__download-text-discount">{{ $t('components.footer.links_and_app.discount_amount') }}</span>
				{{ $t('components.footer.links_and_app.for_first_rent') }}
			</p>
			<div class="links-and-app__download">
				<a
					style="position: relative; z-index: 10"
					href="https://apps.apple.com/pl/app/carfree-rent-a-car/id6802304361"
					rel="nofollow noopener"
					target="_blank">
					<GlobalImage style="height: 32px; width: auto" src="app-store-x2.png" alt="app store" provider="none" :width="256" :height="80" />
				</a>
				<a
					style="position: relative; z-index: 10"
					href="https://play.google.com/store/apps/details?id=pl.carfree.app"
					rel="nofollow noopener"
					target="_blank">
					<GlobalImage
						style="height: 32px; width: auto"
						src="google-play-x2.png"
						alt="google play"
						provider="none"
						:width="276"
						:height="80" />
				</a>
			</div>
			<GlobalImage
				class="links-and-app__image links-and-app__image--2"
				alt="footer-phone-2"
				src="footer-phone-2.png"
				provider="none"
				:width="344"
				:height="170" />
			<GlobalImage
				class="links-and-app__image links-and-app__image--1"
				alt="footer-phone-1"
				src="footer-phone-1.png"
				provider="none"
				:width="533"
				:height="206" />
			<GlobalImage
				class="links-and-app__image links-and-app__image--mobile"
				alt="footer-phone-mobile"
				src="footer-phone-mobile.png"
				provider="none"
				:width="208"
				:height="206" />
		</div>
	</div>
</template>

<style scoped lang="scss" src="./LinksAndApp.scss"></style>
